export const isExpeditedApplication = (application) => {
  return application?.isExpedited || false;
};
